module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('ModalBase', {
    attrs: {
      "withContent": true
    },
    on: {
      "close": _vm.close
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.trads.label))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.trads.subhead.interpolate({
    width: _vm.data.width,
    height: _vm.data.height
  })))]), _vm._v(" "), _c('section', [(_vm.loading) ? _c('Spinner', {
    style: ({
      position: 'absolute'
    })
  }) : _vm._e(), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.trads.pickCaddyLabel))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.caddy),
      expression: "caddy"
    }],
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.caddy = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("––––")]), _vm._v(" "), _vm._l((_vm.allCaddies || []), function(caddy, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": caddy
      }
    }, [_vm._v("\n                " + _vm._s(_vm.trads.caddyOption.interpolate({
      name: caddy.terms.name[_vm.$locale] && caddy.terms.name[_vm.$locale].value,
      width: caddy.config.width,
      height: caddy.config.height
    })) + "\n            ")])
  })], 2), _vm._v(" "), (_vm.caddy) ? _c('fragment', [_c('div', [_c('label', [_vm._v(_vm._s(_vm.trads.horizontalCount))]), _vm._v(" "), _c('NumberInput', {
    model: {
      value: (_vm.horizontalCount),
      callback: function($$v) {
        _vm.horizontalCount = $$v
      },
      expression: "horizontalCount"
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', [_vm._v(_vm._s(_vm.trads.verticalCount))]), _vm._v(" "), _c('NumberInput', {
    model: {
      value: (_vm.verticalCount),
      callback: function($$v) {
        _vm.verticalCount = $$v
      },
      expression: "verticalCount"
    }
  })], 1), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.trads.spacingLabel))]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.trads.horizontalSpacing))]), _vm._v(" "), _c('NumberInput', {
    attrs: {
      "disabled": _vm.horizontalCount < 2
    },
    model: {
      value: (_vm.horizontalSpacing),
      callback: function($$v) {
        _vm.horizontalSpacing = $$v
      },
      expression: "horizontalSpacing"
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.trads.verticalSpacing))]), _vm._v(" "), _c('NumberInput', {
    attrs: {
      "disabled": _vm.verticalCount < 2
    },
    model: {
      value: (_vm.verticalSpacing),
      callback: function($$v) {
        _vm.verticalSpacing = $$v
      },
      expression: "verticalSpacing"
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.trads.paddingLabel))]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.trads.leftPadding))]), _vm._v(" "), _c('NumberInput', {
    model: {
      value: (_vm.padding.left),
      callback: function($$v) {
        _vm.padding.left = $$v
      },
      expression: "padding.left"
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.trads.rightPadding))]), _vm._v(" "), _c('NumberInput', {
    model: {
      value: (_vm.padding.right),
      callback: function($$v) {
        _vm.padding.right = $$v
      },
      expression: "padding.right"
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.trads.topPadding))]), _vm._v(" "), _c('NumberInput', {
    model: {
      value: (_vm.padding.top),
      callback: function($$v) {
        _vm.padding.top = $$v
      },
      expression: "padding.top"
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.trads.bottomPadding))]), _vm._v(" "), _c('NumberInput', {
    model: {
      value: (_vm.padding.bottom),
      callback: function($$v) {
        _vm.padding.bottom = $$v
      },
      expression: "padding.bottom"
    }
  }), _vm._v(" "), _c('footer', [_c('RoundedButton', {
    attrs: {
      "disabled": !_vm.canSave
    },
    on: {
      "click": _vm.validate
    }
  }, [_vm._v(_vm._s(_vm.trads.save))]), _vm._v(" "), _c('RoundedButton', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.trads.cancel))])], 1)], 1) : _vm._e()], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c76648d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plano/edits/generate_fixings/index.vue
// module id = 3009
// module chunks = 0